import {useSessionStore} from "@/utils/useSessionStore.js";
import dayjs from "dayjs";

export function timeAgo(date) {
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  const minutes = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return dateFormat(date, 'mm-dd')
  }
  if (hours > 0) {
    return `${hours} 시간 전`;
  }
  if (minutes > 0) {
    return `${minutes} 분전`;
  }
  return "방금";
}

export function dateFormat(date, format) {
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }
  let day = date.getDate();
  if (day < 10) {
    day = '0' + day;
  }

  if (format === 'yy-mm-dd') {
    return `${date.getFullYear()}-${month}-${day}`
  }

  if (format === 'mm-dd') {
    return `${month}-${day}`
  }

  let fullYear = date.getFullYear();

  return `${fullYear}-${month}-${day}`
}


export function expDateFormat(it_expdate) {
  if(!it_expdate) return null;

  const session = useSessionStore();
  const today = dayjs();
  const date = dayjs(it_expdate);
  if (date.diff(today, 'day') < 1) {
    return null;
  }


  let formatDate = session?.isKorean
    ? date.format('M/D')
    : date.format('MMM/D(ddd)');

  if (session?.isKorean) {
    const weeks = ['일', '월', '화', '수', '목', '금', '토'];
    formatDate = formatDate + "(" + weeks[date.day()] + ")"
  }

  return formatDate
}
